import { userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    if (userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"])) {
      return true;
    }

    return false;
  },
};
